export default __webpack_public_path__ + "static/media/prosper-main.3578eee6.svg";